import http from 'conversations-http/clients/http';
export const fetchGenericChannels = () => http.get('/conversations-channels/v1/generic-channels');